export default {
  header_menu1: 'Resumen',
  header_menu2: 'portafolio',
  header_menu3: 'reportes',
  header_menu4: 'noticias',

  header_menu5: 'Fundamentales',

  user_settings: 'Configuraciones de usuario',
  notifications: 'Notificaciones',
  jobs_in_background: 'Trabajos en 2do plano',

  sidemenu_group1: 'NIVELES',
  sidemenu_group2: 'BANCO Y CATEGORÍA',
  sidemenu_group3: 'GRUPOS PERSONALIZADOS',
  sidemenu_group4: 'GRUPOS MULTIPLES',

  month_names: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'], 
  month_names_short: ['Ene.','Feb.','Mar.','Abr.','May.','Jun.','Jul.','Ago.','Sep.','Oct.','Nov.','Dec.'],
  day_names: ['Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado'],
  day_names_short: ['Dom.','Lun.','Mar.','Mie.','Jue.','Vie.','Sab.'],
  today: 'Hoy',
  start_date: 'Fecha de inicio',
  start_date_type: 'Tipo de fecha de inicio',
  end_date: 'Fecha de fin',
  profit_start_date: 'Profit Start Date',
  last_twelve_months: 'Últimos 12 meses',
  ytd: 'YTD',
  mtd: 'MTD',
  to_day: 'AL DÍA',

  loading: 'Cargando...',
  action: "Acción",
  actions: "Acciones",
  error: 'Ha ocurrido un error inesperado.',
  error_notification: 'Descripcion de error',
  error_help: 'Sería de mucha ayuda para nosotros que nos expliques la situación en la cual surgió este error.',
  error_jwt_help: 'No hemos podido procesar el token JWT proporcionado en los parámetros, detalles del error:',
  ask_feedback: 'Escribe una descripción de la situación aqui...',
  error_sent_title: 'Muchas gracias!',
  error_sent: 'El error junto a la descripción ha sido enviada exitosamente. Pronto estaremos en proceso de revisar las causas, puede que nos pongamos en contacto contigo para conocer mayores detalles.',

  alert_error: 'Correo electrónico o contrasaña inválido.',
  azure_error: 'Este correo no se encuentra registrado en la plataforma',
  send_email_error: 'El correo electrónico no existe',
  send_email_success: 'Recibirás un email con instrucciones de como resetear tu contraseña en unos minutos.',
  alert_expiration: 'Tu sesión ha expirado.',
  alert_error_coordinates: 'Coordenadas inválidas.',
  cancel_login: 'Cancelar inicio de sesión',
  enter: 'Ingresar',
  enterAzure: 'Ingresar con Azure',
  enter_coordinates: 'Ingrese los datos de su tarjeta de coordenadas',
  enter_otp: 'Introduce el código de 6 dígitos que ha sido enviado al correo',
  login: 'Iniciar sesión',
  send_email: 'Enviar Correo Electrónico',
  forget_password: '¿Olvidaste la contraseña?',

  alert_expiration: 'Tu sesión ha expirado.',

  email: 'Correo electrónico',
  password: 'Contraseña',

  select_date_range: 'Seleccionar rango de fechas',
  select_date: 'Seleccionar fecha',

  new_group: 'Nuevo grupo',
  new_view: 'Nueva vista',
  create_new_view: 'Crear nueva vista',
  select_view: 'Seleccionar vista',

  config_active_table: 'Configurar tabla de activos',
  active_table: 'Tabla de activos',
  asset_detail_table: 'Tabla de detalle de activos',

  element_name: 'Nombre',
  element_diferent_date: 'Definir fecha final diferente a la propuesta',
  element_title: 'Agregar un título al elemento',
  element_all_assets: 'Todos los activos',
  element_select: 'Selecciona un elemento',
  element_add: 'Agregar elemento',
  element_assets_by_custodian: 'Activos por custodios',
  element_assets_by_society: 'Activos por sociedad',
  element_assets_only_final_levels: 'Activos solo niveles finales',
  element_assets_by_bank_and_category: 'Activos por banco y categoría',
  element_donut_chart_by_bank_and_category: 'Gráfico Anillo por banco y categoría',
  element_total_custodian_account: 'Total segun custodio/cuenta y monedas',
  element_total_society_account: 'Total segun sociedad/cuenta y monedas',
  element_projected_cash_flow_table: 'Tabla de flujo de caja proyectado',
  element_projected_cash_flow_monthly_bar_chart: 'Grafico de barras mensual de flujo de caja proyectado',
  element_projected_cash_flow_anual_bar_chart: 'Grafico de barras anual de flujo de caja proyectado',

  title_group: 'Nombre del grupo',
  title_view: 'Nombre de la vista',
  bank_category_1: 'Bank category 1',
  bank_category_2: 'Bank category 2',
  bank_category_3: 'Bank category 3',
  bank_category_4: 'Bank category 4',
  bank_category_5: 'Bank category 5',
  select: 'Selecciona',
  levels_preview: 'Previsualización de niveles',
  is_leaves: 'Sólo hojas',

  collapse_all: 'Ocultar subniveles',
  expand_all: 'Mostrar subniveles',
  select_all: 'Seleccionar todo',
  select_any: 'Nada',

  search_placeholder: 'Escribe aquí para buscar...',

  add_bank: 'Agregar banco...',
  add_level: 'Agregar nivel...',
  add_group_level: 'Agregar grupo/nivel...',
  write_group_name: 'Escribe el nombre del grupo...',
  write_view_name: 'Escribe el nombre de la vista...',

  selected_levels: 'Niveles seleccionados',
  selected_groups_levels: 'Grupos/Niveles seleccionados',
  no_levels: "Este grupo no posee ningún nivel",
  no_groups: "No existen grupos en esta categoría.",

  delete_view: 'Eliminar vista',
  delete_group: 'Eliminar grupo',
  delete_multiple_group: 'Eliminar grupo multiple',
  confirm_delete_group: '¿Estás seguro que deseas borrar este grupo de forma permanente?',
  confirm_delete_set: 'Si borras este conjunto, la única forma de volver a mostrarlo es reiniciando por completo los conjuntos de la tabla. ¿Borrar de todas formas?',
  show_asset_set_detail: 'Ver información del conjunto',

  footer: 'Fintree Financial Services. All rights reserved.',

  back: 'Atrás',

  save: 'Guardar',
  saving: 'Guardando',

  sure_you_want_to_delete_the_view: '¿Seguro desea eliminar la vista?',

  // Portfolio
  calculate_pme: 'Calcular PME',
  skip_pme_dividends: 'Saltar dividendos en calculo PME?',

  // Dynamic report Routes
  generate_reports: "Generar reportes",
  report_history: "Historial de reportes",
  version_administration: "Gestionar versiones",
  custom_design: "Personalizar Reporte",
  styles_custom_reports: "Estilos Reportes Personalizados",
  style_settings_optional: "Configuraciones de estilos (OPCIONAL)",
  reports_types: 'Tipos de Reportes',
  reports_types_description: 'Puedes personalizar los colores para cada reporte específico. No obstante, el Statement Completo determina la paleta de colores predeterminada.',

  // Report generation button Text
  level: "Nivel",
  group: 'Grupo',
  group_level: "Grupo/Nivel",
  reference_level: "Nivel de referencia",
  select_level: "Seleccionar nivel",
  select_group_level: 'Seleccionar grupo/nivel',
  profile: "Versión",
  select_profile: "Seleccionar versión",
  select_attribute: "Hojas de atributos",
  generate_preview: "Generar vista previa",
  generate_report: "Generar reporte",
  consult_report: "Consultar informe",
  statement_version: "Version de Statement",
  include_YTD_pages: "Incluir hojas de YTD",
  monetary_unit: "Unidad Monetaria",
  include_page_numbers: "Incluir números de página",
  show_report: "Ver reporte generado",
  please_wait: "Por favor espere...",

  // Report generation specific alerts
  generating_preview: "Generando vista previa...",
  generating_report: "Generando reporte...",
  generated_report: "Reporte generado exitosamente",
  sieteA_error: "Error interno, codigo: ",

  // Report generation specific Strings
  preview: "Vista previa",
  preview_disclaimer: "ATENCION: Esta vista previa no garantiza que no hayan errores en la generacion del reporte.",

  // Version management specific buttons
  new_version: "Crear nueva versión",
  edit_version: "Editar versión",
  delete_version: "Borrar versión",
  save_version: "Guardar",
  cancel: "Cancelar",
  categories: "Seleccionar páginas",
  return: "Volver",

  // Version management specific strings
  name: "Nombre",

  // Version management specific alerts
  confirm_delete_version: "¿Esta seguro que desea borrar esta versión?",
  confirm_delete_notification: "¿Esta seguro que desea borrar esta notificación?",
  saved_version: "Se ha guardado exitosamente la versión ",
  edited_version: "Se ha editado exitosamente la versión ",

  // Reports view
  landing_report: "En el menú de la izquierda se proporciona la capacidad de gestionar una serie de versiones, que servirán para generar uno o más reportes.",
  write_name: "Escribe un nombre...",
  pages_selected: "Páginas seleccionadas",
  no_pages_selected: "No se ha seleccionado ninguna página aún. Para seleccionar una, presiona en alguna categoria.",
  list_version: "Lista de versiones",
  list_report: "Lista de reportes",
  order_pages: "Es posible reordenar las páginas al arrastrarlas",
  not_exist_report: "No se han generado reportes",
  not_exist_version: "No se han creado versiones",

  // Reports names
  statement_complete: 'Statement completo',
  tax_report: 'Informe tributario',
  alternatives: 'PDF Alternativos',
  investment_proposal: 'Reportes Personalizados',

  // Headers tables in reports
  header_id: "ID",
  header_name: "Nombre",
  header_version_statement: "Versión Statement",
  header_pages: "Páginas",
  header_start_date: "Fecha de creación",
  header_um: "U. Monetaria",
  header_status: "Estado",
  header_edit_date: "Fecha de edición",
  header_action: "Acción",

  // Tooltip icon
  create: "Crear",
  edit: "Editar",
  delete: "Borrar",
  download_pdf: "Descargar PDF",
  download_xlsx: "Descargar XLSX",
  show_pdf: "Ver PDF",
  show_error: "Ver error",
  calculate: 'Calcular',

  // Fundamental Table Names
  cash_flow: "Flujo de caja",
  income_statement: "Estado de resultados",
  balance_sheets: "Balance",
  credit_metrics: "Metricas de credito",

  // Bond information strings
  asset: "Activo",
  isin: "ISIN",
  business: "Empresa",
  Frequency: "Frecuencia",
  rate: "Rate",
  emission_date: "Fecha Emision",
  expiration_date: "Vencimiento",
  bond_type: "Tipo Bono",
  next_call_date: "Fecha Proximo Call",
  next_call_price: "Precio Proximo Call",

  // Commercial bond information
  ask_price: "Ask Price",
  bid_price: "Bid Price",
  ytm: "YTM",
  ytw: "YTW",
  duration: "Duración",

  // Emissions table headers
  emision: "Emision",

  // Section News
  show_details: "Ver detalles",
  details_of_news: "Detalle de la noticia",
  more_details: "Más detalles de la noticia",
  news_for: "Noticias para",
  news: 'Noticias',
  open_news: 'Abrir Noticias',
  open_eerr: 'Abrir EERR',
  see_all_the_news: 'Ver todas las noticias',
  search_news: "Buscar noticias",
  search_asset: "Buscar Activo",
  search: "Buscar",
  list_news: "Lista de noticias",
  list_assets: "Lista de activos",
  not_found_news: "No se encontraron noticias para",
  not_found_elements: "No se han encontrado elementos.",
  assets: "Activos",
  cannot_display_data_on_an_asset_that_is_a_monetary_unit: 'No se pueden mostrar datos sobre un activo que es Unidad Monetaria',
  cannot_edit_base_setting: 'No puedes editar una configuración base, \nselecciona otra o crea una nueva',

  // Fact Sheet Fund
  assets_distributions: "Distribución de Activos",
  countries: "Paises",
  coins: "Monedas",
  industries: "Industrias",

  // Statement list status
  starting_process: 'Iniciando Proceso',
  done: 'Finalizado',
  running: 'En proceso...',
  enqueue: 'En cola...',
  failed: 'Error',

  // Benchmark
  empty_benchmark_guide: "Benchmark vacío, agrega una serie presionando en alguno de los siguientes botones",
  isolated_asset: 'Activos Aislados',
  custodian: 'Custodios',
  grouping: 'Agrupación',
  view_rolling_data: 'Ver Datos Rolling',
  months: 'meses',
  rolling: 'Rolling',
  series_volatility_annualized_return: 'Serie (Volatilidad, Retorno Anualizado)',
  sharp_ratio: 'Sharp Ratio',
  percentage_observations: '% Observaciones',
  percentage_change: 'Variación Porcentual',
  accumulated_profit: 'Utilidad Acumulada',
  create_excel: 'Crear Excel',
  create_theoretical: 'Crear Teórico',
  benchmark_edited_successfully: 'Benchmark editado exitosamente',
  rolling_interval_months: 'Intervalo Rolling (meses)',
  histogram_interval: 'Intervalo Histograma',
  write_benchmark_name: 'Escribir nombre benchmark',
  benchmark_name: 'Nombre Benchmark',
  benchmark: 'Benchmark',

  top10Holdings: "Top 10 Holdings",

  // Benchmark Real Set
  real_set: 'Conjunto Real',
  title_new_real_set: 'Agregar nuevo conjunto real',
  title_step_one: 'Datos generales',
  title_step_two: 'Crear conjunto de activos',
  title_step_three: 'Seleccionar grupo de niveles',
  serie_name: 'NOMBRE SERIE',

  // Selectable Levels
  change_method_to_select_levels: 'Cambiar método de selección grupo de niveles',
  personalized: 'Personalizado',
  bank_category: 'Banco y categoría',
  individual_level: 'Seleccionar nivel individual',
  create_level_group: 'Crear grupo de niveles',
  select_existing_group: 'Seleccionar grupo existente',
  level_list: 'Lista de niveles',
  level_selected: 'Nivel seleccionado',
  group_selected: 'Grupo seleccionado',
  levels: 'Niveles',
  load_existing_group: 'Cargar grupo existente',
  loading_levels: 'Cargando niveles',

  // Selectable Filters
  add_filter: 'Presione para agregar un filtro',

  // Benchmark Theoretical Set
  theoretical_set: 'Conjunto Teórico',
  title_step_four: 'Construir conjunto teórico',
  from_actual_result: 'A partir de resultado real',
  theoretical_projection_from_a_photo_of_the_portfolio_to_a_date: 'Proyección teórica a partir de una foto del portafolio a una fecha',
  theoretical_projection_from_a_modified_photo_of_the_portfolio_to_a_date: 'Proyección teórica a partir de una foto modificada del portafolio a una fecha',
  modify_portfolio: 'Modificar portafolio',

  // Sortable components
  edit_field: 'Editar campo',
  // Asset Allocation
  update_view: 'Editar vista',

  show_less: 'mostrar menos',
  show_more: 'mostrar más',

  // Bonds Panel Module
  capital: 'Capital',
  Interest: 'Interés',
  capital_interest: 'Capital/Interés',
  type_of_assets: 'Tipo de activos',
  show_valid_assets: 'Mostrar Activos Vigentes',

  // Custom pdf report
  version_name: 'Nombre versión',
  enter_name: 'Ingresar nombre',
  enter_template_name: 'Ingresar nombre plantilla',
  delete_template: 'Eliminar template',
  add_color: 'Agregar color',
  save_color_settings: 'Guardar Configuración de Colores',
  color_setting: 'Configuración de Colores',
  color_settings: 'Configuraciones de Colores',
  table_settings: 'Configuraciones de Tablas',
  table_setting: 'Configuración de Tabla',
  save_table_settings: 'Guardar Configuraciones de Tabla',
  color: 'Color',
  tag_name: 'Nombre etiqueta',
  save_tag_settings: 'Guardar Configuración de Etiquetas',
  add_tag: 'Agregar etiqueta',
  tag_setting: 'Configuración de Etiquetas',
  tag_settings: 'Configuraciones de Etiquetas',
  general_settings: 'Configuraciones Generales',
  general_setting: 'Configuración General',
  save_general_settings: 'Guardar Configuraciones Generales',
  chart_color_settings: 'Configuraciones de Colores de Gráficos',
  chart_color_setting: 'Configuración de Colores de Gráficos',
  color_settings: 'Configuraciones de Colores',
  color_setting: 'Configuración de Colores',
  horizontal_table_settings: 'Configuraciones de Tablas Horizontales',
  horizontal_table_setting: 'Configuracion de Tabla Horizontal',
  vertical_table_settings: 'Configuraciones de Tablas Verticales',
  vertical_table_setting: 'Configuracion de Tabla Vertical',
  customize_report: 'Personalizar Reporte',

  // Custom pdf reports (texts combobox)
  header_base: 'Cabecera base',
  header_simple: 'Cabecera simple',
  no_header: 'Sin cabecera',
  front_base: 'Portada base',
  front_simple: 'Portada simple',
  no_front: 'Sin portada',

  profitability_evolution: 'Evolución rentabilidad',
  heritage_evolution: 'Evolución patrimonio',
  monthly_returns: 'Rentabilidades mensuales',

  open_fact_sheet: 'Abrir Fact Sheet',
  show_sales: 'Ver ventas',

  // views
  successfully_updated_view: 'Vista editada existosamente',
  successfully_created_view: 'Vista creada existosamente',
  successfully_deleted_view: 'Vista eliminada existosamente',
  no_view_selected: 'No se ha seleccionado ninguna vista',

  // Investment proposal
  there_are_no_records: 'No existen registros',
  loading_records: 'Cargando registros',
  there_are_no_movements: 'No existen movimientos',
  exceed_the_maximum: 'Excede el máximo',
  movements: 'Movimientos',
  minimize: 'Minimizar',
  maximize: 'Maximizar',
  add_amount: 'Agregar monto',
  add_nominals: 'Agregar nominales',
  add_nominal: 'Agregar nominal',
  price: 'Precio',
  maximum: 'Máximo',
  select_asset: 'Seleccionar activo',
  buy: 'Comprar',
  sell: 'Vender',
  maximum_of_nominals: 'Máximo de nominales',
  current_quantity: 'Nominales actuales',
  indicators: 'Indicadores',
  price_serie: 'Serie de precios',
  no_asset_selected: 'No hay activo seleccionado',
  new_page: 'Nueva página',
  remove: 'Eliminar',
  delete_page: 'Eliminar página',
  are_you_sure_you_want_to_delete_the_page: '¿Seguro desea eliminar la página?',
  delete_page: 'Eliminar template',
  are_you_sure_you_want_to_delete_the_template: '¿Seguro desea eliminar el template?',
  investment_proposals: 'Propuestas de inversión',
  templates: 'Templates',
  proposals: 'Propuestas',
  new_template: 'Nuevo template',
  new_proposal: 'Nueva propuesta',
  are_you_sure_you_want_to_delete_the_proposal: '¿Seguro desea eliminar la propuesta?',
  asset_filter: 'Filtro de Activos',
  title: 'Título',
  select_columns: 'Seleccionar columnas',
  columns: 'Columnas',
  accounting_event: 'Evento contable',
  asset_name: 'Nombre activo',
  select_monetary_unit: 'Seleccionar unidad monetaria',
  investment_proposal_template: 'Templates Propuesta de Inversion',
  monetary_unit_accounting_events: 'Unidad Monetaria Cálculos Contables',
  successfully_created_setting: 'Configuración creada exitosamente',
  successfully_updated_setting: 'Configuración editada exitosamente',
  historical_and_projected_flows: 'Flujos Históricos y Proyectados',
  evolution_commitment: 'Evolución Commitment',
  projection_allocation: 'Proyección Allocation',
  style_settings: 'Configuración de estilos',
  asset_grouping: 'Agrupación de activos',
  portfolio_grouping: 'Agrupación de portafolio',
  date_to_consider: 'Fecha a considerar',
  allocation_three_d_pie_chart: 'Gráfico Pie 3D',
  allocation_column_chart: 'Gráfico Columnas',
  monthly_profitability_table: 'Tabla de Rentabilidad Mensual',
  monthly_profitability_column_chart: 'Gráfico Columnas Rentabilidad Mensual',
  monthly_profitability_line_chart: 'Gráfico Linea Rentabilidad Mensual Acumulada',
  monthly_profitability_column_line_chart: 'Gráfico Columnas y Linea Rentabilidad Mensual',

  //Text Editor
  format: 'Formato',
  align: 'Alineación',
  text_color: 'Color texto',
  background_color: 'Color fondo',
  text_size: 'Tamaño texto',
  write_your_text_here: 'Escriba su texto acá',
  select_option: 'Seleccionar opción',
  total: 'Total',
  net_amount_movements: 'Monto neto movimientos',
  investment_proposal: 'Propuesta de inversión',

  //Private Equity
  simulate_investment: 'Simular Inversión',
  select_simulation: 'Seleccionar simulación',
  update_simulation: 'Editar simulación',
  new_simulate: 'Crear simulación',
  add_simulate_name: 'Ingresar Nombre Simulación',
  name_simulation: 'Nombre Simulación',
  amounts_to_pledge: 'Monto a promesar',
  percentage: 'Porcentaje',
  vintage_year: 'Año Vintage',
  useful_life: 'Duración del Fondo',
  investment_lifetime: 'Periodo de Inversión',
  projected_moic: 'MOIC esperado',
  projected_tir: 'TIR esperada',
  benchmark_estimated_tir: 'TIR Benchmark',
  add_commitment: 'Agregar promesa',
  general_totals: 'Totales Generales',
  amount: 'Monto',
  attribute: 'Atributo',
  grouping_attribute: 'Atributo para Agrupación',
  time_frame: 'Periodo de tiempo',
  periods_to_graph: 'Periodos a graficar',
  simulation_removed_successfully: 'Simulación eliminada exitosamente',
  simulation_created_successfully: 'Simulación creada exitosamente',
  simulation_updated_successfully: 'Simulación editada exitosamente',
  commitment_data: 'Datos de la Promesa',
  attribute_and_amount: 'Atributo y Monto',
  simulation_grouping_not_belongs_to_view_grouping: 'La agrupación de la simulación no pertenece a la agrupación de la vista',
  delete_simulation: 'Eliminar simulación',
  sure_you_want_to_delete_the_simulation: '¿Seguro desea eliminar la simulación?',
  reset_selection: 'restablecer selección',

  correlations: 'Correlaciones',
  correlations_chart: 'Gráfico Correlaciones',

  tracking_error: 'Tracking Error',

  delete_all: 'Eliminar Todo',
  settings: 'Configuraciones',
  sign_out: 'Cerrar Sesión',
  welcome: 'Bienvenido',
  select_reference_benchmark: 'Seleccionar Referencia Benchmark',
  asset_flows: 'Flujos por Activos',
  anual_summary: 'Resumen Anual',

  replace_ytm_ytw_by_tir_uf_tir_clp: 'Reemplazar YTM/YTW por TIR UF/TIR CLP',
  select_charts_to_display: 'Seleccionar gráficos a mostrar',

  // Structured Notes
  structured_notes: 'Nota Estructurada',
  amount_invested: 'Monto Invertido',
  mkt: 'MKT',
  purchase_date: 'Fecha de Compra',
  first_next_dividend: 'Próxima Revisión',
  second_next_dividend: 'Revisión Subsiguiente',
  frequency: 'Periocidad Observaciones',
  coupon: 'Cupón',
  index: 'Índice',
  capital_protection: 'Protección Capital',
  coupon_protection: 'Protección Cupón',
  initial_index_level: 'Nivel Inicial de Índice',
  capital_protection_level: 'Nivel Protección Capital',
  coupon_protection_level: 'Nivel Protección Cupón',
  index_price: 'Nivel Índice Actual',
  capital_buffer: 'Colchón Capital',
  coupon_buffer: 'Colchón Cupón',
  called: 'Implicancia al Vencimiento',
  coupon_won: '¿Se gana el cupón?',
  graph_options: 'Opciones de los Gráficos',
  graph_options_title: 'Opciones para el gráfico',
  duration_until_expiration: 'Duración hasta el vencimiento',
  duration_until_expiration_info: 'Proyectar flujos futuros asumiendo que cada nota va a durar hasta el vencimiento',
  coupon_prices_with_index: 'Pago cupón con precios de índices',
  coupon_prices_with_index_info: 'Proyectar flujos futuros usando los precios de los índices actuales',
  issuer_callable_are_called: 'Notas Issuer Callable son llamadas',
  issuer_callable_are_called_info: 'Proyectar flujos futuros asumiendo que las notas Issuer Callable pueden ser llamadas',
  projected_cash_flow: 'Flujo de Caja Proyectado',
  monthly_payment: 'Pago Mensual',
  enter_title: 'Ingrese título',
  table_columns: 'Columnas de la tabla',
  issuer: 'Emisor',
  distribution: 'Distribución',
  vix: 'VIX',
  fixed_income_yield: 'Yield Renta Fija',
  fixed_income_asset: 'Activo Renta Fija',

  // Attribution View
  black_litterman: 'Black Litterman',
  benchmark_percentage: '% Benchmark',
  benchmark_asset: 'Activo Benchmark',
  benchmark_return: 'Rentabilidad Benchmark',
  benchmark_volatility: 'Volatibildad Benchmark',
  use_historic_prices: 'Usar Precios Historicos', 
  expected_return: 'Rentabilidad Esperada',
  confidence: 'Intervalo de Confianza',
  historic_returns: 'Retornos Historicos',
  input_returns: 'Retornos Ingresados',
  weighted_returns: 'Retornos Ponderados',
  calculate_returns: 'Calcular Rentabilidades',
  returns: 'Retornos',
  returns_label: 'Rentabilidad',
  covariance_matrix: 'Matriz Covarianza',
  risk_asset_class: 'Riesgo Activo Clase',
  risk_asset_subclass: 'Riesgo Activo Subclase',
  risk_region: 'Riesgo Región',
  risk_market: 'Riesgo Mercado',


  // Attribution View
  black_litterman: 'Black Litterman',
  benchmark_percentage: '% Benchmark',
  benchmark_asset: 'Activo Benchmark',
  benchmark_return: 'Rentabilidad Benchmark',
  benchmark_volatility: 'Volatibildad Benchmark',
  use_historic_prices: 'Usar Precios Historicos', 
  expected_return: 'Rentabilidad Esperada',
  confidence: 'Intervalo de Confianza',
  historic_returns: 'Retornos Historicos',
  input_returns: 'Retornos Ingresados',
  weighted_returns: 'Retornos Ponderados',
  calculate_returns: 'Calcular Rentabilidades',
  returns: 'Retornos',
  returns_label: 'Rentabilidad',
  covariance_matrix: 'Matriz Covarianza',

  // Client Board
  report: 'Reporte',
  reports: 'Reportes',
  financial_portfolio_growth_rate_percentage: 'Tasa de crecimiento cartera financiera (porcentual)',

  client_board_reports: 'Reportes',
  x_axis: 'Eje X',
  y_axis: 'Eje Y',
  select_rows: 'Seleccionar filas',
  metrics: 'Métricas',
  visualization: 'Visualización',
  select_column: 'Selecciona una columna',
  select_operation: 'Seleccione una operación',
  filters: 'Filtros',
  dynamic_table: 'Tabla Dinámica',
  dynamic_tables: 'Tablas Dinámicas',
  weigh: 'Ponderar',
  view_name: 'Nombre Vista',
  date: 'Fecha',
  update_data: 'Actualizar datos',
  use_existing_data: 'Usar datos existentes',
  are_you_sure_you_want_to_delete_the_record: '¿Seguro desea eliminar el registro?',
  data_corresponding_to_the_report_generated_on: 'Datos correspondientes al informe generado el',
  the_report_is_taking_a_little_longer_than_expected_please_wait: 'El reporte se está demorando un poco más de la cuenta, espere por favor',

  save_dynamic_table: 'Guardar Vista de Tabla Dinámica',
  update_data_source: 'Editar Origen de Datos',
  new_data_source: 'Nuevo Origen de Datos',
  confirm_operation: 'Confirmar Operación',
  dynamic_tables_list: 'Lista de Tablas Dinámicas',
  all_assets: 'Todos los Activos',
  add_number: 'Agregar un Nombre',

  custodians_report_total: 'Custodians Report Total',
  final_levels_aum_change_analysis: 'Análisis Cambio AUM Niveles Finales',
  download_xlsx: 'Descargar Excel',
  use_this_data: 'Usar estos datos',
  modify_data: 'Modificar Datos',
  the_report_is_being_generated_in_the_background: 'El Reporte se está generando en segundo plano',
  there_is_no_data_for_the_selected_level: 'No hay datos para el nivel seleccionado',
  generate_data: 'Generar Datos',
  generate_new_data: 'Generar Nuevos Datos',

  apply_asset_filter: 'Considera Filtro de Activos',

  getting_file_from_storage: 'Obteniendo archivo desde el almacenamiento',
  processing_data_from_excel_file: 'Procesando información de archivo excel',
  generating_columns: 'Generando columnas',
  ending: 'Finalizando',

  error_detailed: 'Detalle del Error',

  // Notifications
  important_notice: 'Aviso importante',
  system_update: 'Actualización del sistema',
  novelty: 'Novedades',
  notifications_list: 'Lista de notificaciones',
  all_notifications: 'Todas las notificaciones',
  mark_all_as_read: 'Marcar todas como leídas',
  there_is_not_notification_selected: 'No hay notificación seleccionada',
  there_are_no_notifications: 'No hay notificaciones',

  // Workers
  there_are_no_workers: 'No hay trabajos en 2do plano',

  add_asset: 'Agregar Activo',
  list_of_added_assets: 'Lista de Activos Agregados',
  list_of_existing_real_sets: 'Listado de conjuntos reales existentes',
  statistics: 'Estadísticas',
  series: 'Series',
  list_of_assets_sets: 'Listado de activos/conjuntos',
  emissions: 'Emisiones',
  bonus_commercial_information: 'Información Comercial Bono',
  bonus_information: 'Información Bono',
  error_reported_it_will_be_attended_to_as_soon_as_possible: 'Error reportado, será atendido a la brevedad.',
  report_error: 'Reportar Error',
  please_report_error: 'Presione aquí para reportar el error',
  an_unexpected_error_has_occurred: 'Ha ocurrido un error inesperado',
  chart_benchmark_version: 'Graficar Versión Benchmark',
  select_series: 'Seleccionar Series',
  selected_elements: 'Elementos Seleccionados',
  availale_elements: 'Elementos Disponibles',
  page_element_manager_description: 'NOTA: Los datos empleados para la generación del gráfico/tabla provienen de los managers configurados al editar el nivel en la aplicación principal.',
  visualization_type: 'Tipo de visualización',
  percentage_table: 'Tabla en porcentajes',
  monetary_table: 'Tabla en montos',
  chart: 'Gráfico',
  show_level_data: 'Mostrar datos de nivel',
  stacked_bar_chart: 'Gráfico de barras apiladas',  
  profit_type: 'Tipo de rentabilidad',
  select_profit_type: 'Seleccionar tipo de rentabilidad',
  edit_page: 'Editar página',
  select_layout: 'Seleccionar diseño',
  delete_layout_item: 'Eliminar elemento',
  restore_layout_item: 'Restaurar elemento',
  add_layout_item: 'Agregar elemento',
  page_settings: 'Configuraciones de la página',
  page_settings_updated_successfully: 'Configuración de página actualizada exitosamente',
  error_updating_page_settings: 'Error al actualizar la configuración de la página',
  error_adding_layout_item: 'No hay espacio suficiente para agregar un nuevo elemento de ',
  error_updating_page_layout: 'Error al actualizar el diseño de la página',
  clone_layout_item: 'Clonar elemento'
}
